import { render, staticRenderFns } from "./HeaderCart.vue?vue&type=template&id=316585ce&"
import script from "./HeaderCart.vue?vue&type=script&lang=ts&"
export * from "./HeaderCart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports